import * as types from './types';

export const init = () => ({
  type: types.INIT,
})

export const toggleLoading = (status) => ({
  type: types.TOGGLE_LOADING,
  status,
});

export const setData = (data) => ({
  type: types.SET_DATA,
  data,
});
